<script setup lang="ts">
import type { IChiefEditorExperience } from '@/entities/journal/model/types';

withDefaults(defineProps<{ data?: IChiefEditorExperience[] }>(), {
  data: () => [],
});

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['experience-section', { _mobile: isMobile }]">
    <div class="experience-section__title">Опыт</div>
    <ul class="experience-section__list">
      <li v-for="(item, index) in data" :key="index" class="experience-section__item">
        <div class="experience-section__name">
          {{ item.position }}
        </div>
        <div class="experience-section__date">
          {{ item.period }}
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.experience-section {
  .flex-column(@size-x6);
  .box-shadow();

  padding: @size-x8;
  border-radius: @main-size;

  &__title {
    font-size: 30px;
    font-weight: 700;
    line-height: 130%;
  }

  &__list {
    .flex-column(@size-x6);
  }

  &__item {
    .flex-column(@main-size);

    position: relative;
    padding-left: 14px;

    &::before {
      content: '';
      position: absolute;
      top: 7px;
      left: 0;
      width: 6px;
      height: 6px;
      background-color: @color-persimmon;
      border-radius: 50%;
    }
  }

  &__name {
    font-size: @size-x4;
    line-height: 130%;
    font-weight: 600;
  }

  &__date {
    font-size: 14px;
    line-height: 130%;
    font-weight: 500;
    color: @color-silver-chalice;
  }

  &._mobile {
    padding: @size-x6;
  }
}
</style>
